import React, { useMemo } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import LanguageSelector from '../components/LanguageSelector';
import { useLanguage } from '../context/LanguageContext';

const NAVY = '#14213d';
const GOLD = '#C9A84C';

const TYPES = [
  {
    id: 'owner',
    path: 'owner/type',
    titleKey: 'surveyOwnerTitle',
    subtitleKey: 'surveyOwnerSubtitle',
    titleFallback: 'Machine Owner',
    subtitleFallback: 'Fleet owner · JCB / excavator',
  },
  {
    id: 'client',
    path: 'client/profession',
    titleKey: 'surveyClientNeedTitle',
    subtitleKey: 'surveyClientNeedSubtitle',
    titleFallback: 'I Need a Machine',
    subtitleFallback: 'Hire equipment for your project',
  },
];

const shellStyle = {
  minHeight: '100vh',
  background: `linear-gradient(180deg, ${NAVY} 0%, #0a1628 100%)`,
  color: '#e8ecf1',
  fontFamily: "'Noto Sans Devanagari', 'Plus Jakarta Sans', sans-serif",
};

export default function SurveyLanding() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { t } = useLanguage();

  const querySuffix = useMemo(() => {
    const next = new URLSearchParams();
    const by = searchParams.get('by');
    const src = searchParams.get('src');
    if (by) next.set('by', by);
    if (src) next.set('src', src);
    const s = next.toString();
    return s ? `?${s}` : '';
  }, [searchParams]);

  const selectType = (path) => {
    navigate(`/survey/${path}${querySuffix}`);
  };

  return (
    <div style={shellStyle}>
      <header
        style={{
          background: NAVY,
          borderBottom: '1px solid rgba(201,168,76,0.25)',
          padding: '14px 16px',
        }}
      >
        <div
          style={{
            maxWidth: 560,
            margin: '0 auto',
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            gap: 12,
          }}
        >
          <div style={{ minWidth: 0 }}>
            <p
              style={{
                margin: 0,
                fontSize: 11,
                letterSpacing: '0.12em',
                color: GOLD,
                textTransform: 'uppercase',
              }}
            >
              Development Express
            </p>
            <h1 style={{ margin: '4px 0 0', fontSize: 18, fontWeight: 700, color: '#fff' }}>
              Field Survey
            </h1>
          </div>
          <LanguageSelector compact />
        </div>
      </header>

      <main style={{ maxWidth: 560, margin: '0 auto', padding: '28px 16px 48px' }}>
        <p
          style={{
            margin: '0 0 8px',
            fontSize: 13,
            letterSpacing: '0.08em',
            textTransform: 'uppercase',
            color: GOLD,
            fontWeight: 700,
          }}
        >
          {t('surveySelectRole') || 'Select your role'}
        </p>
        <h2 style={{ margin: '0 0 8px', fontSize: 22, fontWeight: 800, color: '#fff', lineHeight: 1.3 }}>
          {t('surveyWhoAreYou') || 'Who are you?'}
        </h2>
        <p style={{ margin: '0 0 24px', fontSize: 14, lineHeight: 1.55, color: '#9aa8b8' }}>
          {t('surveyChooseOne') || 'Choose one option to continue.'}
        </p>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {TYPES.map((item) => (
            <button
              key={item.id}
              type="button"
              onClick={() => selectType(item.path)}
              style={{
                display: 'block',
                width: '100%',
                textAlign: 'left',
                padding: '18px 16px',
                borderRadius: 14,
                border: '1px solid rgba(201,168,76,0.45)',
                background: 'linear-gradient(145deg, rgba(201,168,76,0.12) 0%, rgba(20,33,61,0.65) 100%)',
                color: '#e8ecf1',
                cursor: 'pointer',
                boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
                outline: 'none',
                boxSizing: 'border-box',
              }}
            >
              <span style={{ display: 'block', fontSize: 16, fontWeight: 800, color: GOLD }}>
                {t(item.titleKey) || item.titleFallback}
              </span>
              <span style={{ display: 'block', marginTop: 4, fontSize: 13, color: '#c8d0dc' }}>
                {t(item.subtitleKey) || item.subtitleFallback}
              </span>
            </button>
          ))}
        </div>
      </main>
    </div>
  );
}
